import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import { getThemeImages } from '../../../../Themes';
import HintItem from '../HintItem';

import styles from './DetailsScreen.Styles';

const DetailsScreen = ({ onPrivacyPolicyPress, onPrimaryButtonPress }) => {
  const theme = useTheme() || LightThemeColors;
  const images = getThemeImages(theme.name);

  return (
    <View style={styles.contentContainerStyle} testID={FrameworkTestKeys.BLODetailsScreenView}>
      <Icon
        name={images.icNetwork}
        type="image"
        size={101}
        style={styles.networkIconStyle}
        testID={FrameworkTestKeys.BLODetailsScreenIcon}
      />
      <VFText
        i18nKey="background_location_overlay_details_title"
        style={styles.detailsTitleStyle(theme)}
        testKey={FrameworkTestKeys.BLODetailsScreenTitleText}
      />
      <VFText
        i18nKey="background_location_overlay_details_description"
        style={styles.detailsDescriptionStyle(theme)}
        testKey={FrameworkTestKeys.BLODetailsScreenDescriptionText}
      />
      <View
        style={styles.hintsContainerViewStyle}
        testID={FrameworkTestKeys.BLODetailsScreenHintsContainerView}
      >
        <HintItem description={'background_location_overlay_details_first_hint'} />
        <HintItem description={'background_location_overlay_details_second_hint'} />
        <HintItem description={'background_location_overlay_details_third_hint'} />
      </View>
      <VFText
        i18nKey="background_location_overlay_details_how_to_turn_on"
        style={styles.detailsSecondTitleStyle(theme)}
        testKey={FrameworkTestKeys.BLODetailsScreenHowToTurnOnText}
      />

      <VFText
        i18nKey="background_location_overlay_details_go_to_settings_label"
        style={styles.detailsSecondDescriptionStyle(theme)}
        testKey={FrameworkTestKeys.BLODetailsScreenSettignsText}
      />
      <VFText
        i18nKey="background_location_overlay_details_allow_all_the_time_label"
        style={styles.detailsSecondExtraDescriptionStyle(theme)}
        testKey={FrameworkTestKeys.BLODetailsScreenAllowAllText}
      />

      <Icon
        name={images.icTutorial}
        type="image"
        size={360}
        style={styles.tutorialIconStyle}
        testID={FrameworkTestKeys.BLODetailsScreenTutorialIcon}
      />
      <VFButton
        title="background_location_overlay_details_go_to_settings_button_text"
        style={styles.primaryButton}
        onPress={onPrimaryButtonPress}
        testKey={FrameworkTestKeys.BLODetailsScreenSettingsButton}
      />

      <TouchableWithoutFeedback
        onPress={onPrivacyPolicyPress}
        testID={FrameworkTestKeys.BLODetailsScreenTWF}
      >
        <VFText
          i18nKey={'background_location_overlay_details_privacy_policy_label'}
          style={styles.privacyPolicyHyperlinkStyle(theme)}
          testKey={FrameworkTestKeys.BLODetailsScreenPrivacyPolicyText}
        />
      </TouchableWithoutFeedback>
    </View>
  );
};

DetailsScreen.propTypes = {
  onPrivacyPolicyPress: PropTypes.func,
  onPrimaryButtonPress: PropTypes.func,
};

export default DetailsScreen;
